var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent } from 'react';
import { default as AntButton } from 'antd/lib/button';
import { default as AntTooltip } from 'antd/lib/tooltip';
import PropTypes from 'prop-types';
import { services } from '@comall-backend-builder/core';

var Button = function (_super) {
  __extends(Button, _super);

  function Button(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }
  /**
   * 处理按钮的点击事件
   */


  Button.prototype.handleClick = function (event) {
    var onClick = this.props.onClick;

    if (onClick) {
      onClick(event);
    } else {
      services.behaviorHandle(this.props);
    }
  };

  Button.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        style = _a.style,
        text = _a.text,
        type = _a.type,
        htmlType = _a.htmlType,
        children = _a.children,
        icon = _a.icon,
        shape = _a.shape,
        disabled = _a.disabled,
        size = _a.size,
        tooltip = _a.tooltip,
        loading = _a.loading,
        buttonPrivilege = _a.privilege;
    var btnStyle = style;
    var buttonProps = {
      type: type,
      htmlType: htmlType,
      icon: icon,
      shape: shape,
      className: className,
      style: btnStyle,
      disabled: disabled,
      size: size,
      loading: loading,
      onClick: this.handleClick
    };
    var linkProps = {
      className: className,
      style: btnStyle,
      disabled: disabled,
      onClick: this.handleClick
    };
    var content = type === 'link' ? React.createElement("a", __assign({}, linkProps), text || children) : React.createElement(AntButton, __assign({}, buttonProps), text || children);

    if (buttonPrivilege) {
      var path = buttonPrivilege.path,
          level = buttonPrivilege.level;

      if (!services.privilege.check(path, level)) {
        return undefined;
      }
    }

    return tooltip ? React.createElement(AntTooltip, {
      title: tooltip
    }, content) : content;
  };

  Button.propTypes = {
    type: PropTypes.oneOf(['default', 'primary', 'ghost', 'dashed', 'danger', 'link']),
    htmlType: PropTypes.string,
    icon: PropTypes.string,
    shape: PropTypes.oneOf(['circle', 'circle-outline']),
    className: PropTypes.string,
    style: PropTypes.object,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'default', 'large']),
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
    onClick: PropTypes.func
  };
  Button.defaultProps = {
    loading: false
  };
  return Button;
}(PureComponent);

export { Button };